import React from 'react';
import ConfigPanel from '../ConfigPanel';
import OperationDetails from './OperationDetails';
import MacroDetails from './MacroDetails';
import OperatorConfiguration from './OperatorConfiguration';
import { useOperator } from './OperatorProvider';
import NavigationOverrideDetails from './NavigationOverrideDetails';

/**
 * Handles switching between the operator configuration screens
 */
const OperatorPanel = () => {
    const { currentScreen, OPERATOR_SCREENS } = useOperator();

    const getScreen = () => {
        switch (currentScreen) {
            case OPERATOR_SCREENS.configuration:
                return <OperatorConfiguration />;
            case OPERATOR_SCREENS.operationDetails:
                return <OperationDetails />;
            case OPERATOR_SCREENS.macroDetails:
                return <MacroDetails />;
            case OPERATOR_SCREENS.navigationDetails:
                return <NavigationOverrideDetails />;

            default:
                return <OperatorConfiguration />;
        }
    };

    return <ConfigPanel className="operator-config">{getScreen()}</ConfigPanel>;
};

export default OperatorPanel;
